import { ObjectExpression } from "@babel/types";
import { singleton } from "tsyringe";
import { ObjectResult } from "../../../../../types/codeEditor";
import {
  IEvaluatedSchemaMetadata,
  SchemaFormat,
  SchemaType
} from "../../../types";
import { BaseJavascriptFormatSchemaVisitor } from "./base";

@singleton()
export class JavascriptPartialSchemaVisitor extends BaseJavascriptFormatSchemaVisitor {
  get schemaFormat(): SchemaFormat {
    return "javascript";
  }

  get schemaTypes(): SchemaType[] {
    return ["partial"];
  }

  get usingSourceGroup(): boolean {
    return true;
  }

  visitModuleObject(
    moduleObject: ObjectExpression
  ): ObjectResult<IEvaluatedSchemaMetadata> {
    const propertiesValidationResult = this.validateProperties(moduleObject);
    if (!propertiesValidationResult.valid) {
      return ObjectResult.fail<IEvaluatedSchemaMetadata>(
        propertiesValidationResult.errors
      );
    }

    return ObjectResult.ok<IEvaluatedSchemaMetadata>({
      sourceEntityTypes: []
    });
  }
}
